import randomString from "./randomString"

const selector = "input[name=data]"

document.addEventListener("DOMContentLoaded", (e) => {
  const element = document.querySelector(selector)
  const value = randomString(10)

  if (element) {
    element.value = value
  }
})
